import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MDBDataTable } from 'mdbreact';
import Tooltip from '../../common/toolTip';
import axios from 'axios';
import { ROUTE_BASE_URL, baseUrl } from '../../../api/common';
import AdminUserRoleDelete from './delete';
import AdminUserRoleAdd from './add';

const AdminUserRole = () => {

    const [addPopupStatus, setAddPopupStatus] = useState(false);

    const [updateData, setUpdateData] = useState({});

    const [eventType, setEventType] = useState('');

    const handleAddPopup = (status, type, data) => {
        setUpdateData(data);
        setEventType(type);
        setAddPopupStatus(status);
        setViewPopupStatus(false);
    };

    const [viewPopupStatus, setViewPopupStatus] = useState(false);

    const handleViewPopup = (type, data) => {
        setUpdateData(data);
        setEventType(type);
        setViewPopupStatus(true);
    };

    const handleViewPopupClose = () => {
        setEventType('');
        setUpdateData({});
        setViewPopupStatus(false);
    };

    const [deletePopupStatus, setDeletePopupStatus] = useState(false);
    const [deleteId, setDeleteId] = useState();
    const handleDelete = (id) => {
        setDeleteId(id);
        setDeletePopupStatus(true);
    };

    const handleCloseDelete = () => {
        setDeletePopupStatus(false);
        setViewPopupStatus(false);
    };

    const [roleTypeData, setRoleTypeData] = useState([]);

    const fetchRoleTypeData = async () => {
        try {
            const response = await axios.get(
                `${baseUrl}/api/get_role`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: localStorage.getItem('access_token'),
                    },
                }
            );

            if (response.data.status) {
                setRoleTypeData(response.data.data);
            } else {
                console.error('Error: Failed to fetch user data');
            }
        } catch (error) {
            console.error('Error fetching users data:', error);
        }
    };

    const body = {
        columns: [
            {
                label: 'S.No',
                field: 'sno',
                attributes: {
                    style: { width: '2%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Role Type',
                field: 'name',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    style: { width: '50%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Action',
                field: 'action',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Action',
                    style: { width: '1%', fontWeight: 'bold' },
                },
            }
        ],
        rows: roleTypeData && roleTypeData.map((data, index) => ({
            sno: index + 1,
            name: data.role_name || "N/A",
            action: (
                <div>
                    <Tooltip text="View" id="view" />
                    <Link to={`${ROUTE_BASE_URL}/admin-user-permission/${data.id}`}> <button type="button" className="btn btn-sm btn-default" title="View" data-for="view" data-tip><i className="fa fa-eye"></i></button></Link>
                    <Tooltip text="Update" id="update" />
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleAddPopup(true, "Update", data); }}
                        className="btn btn-sm btn-default edit_button_package"
                        title="Edit"
                        data-for="update"
                        data-tip
                    >
                        <i className="fa fa-edit"></i>
                    </button>
                    <Tooltip text="Delete" id="delete" />
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleDelete(data.id); }}
                        className="btn btn-sm btn-default delete_button_package"
                        title="Delete"
                        data-for="delete"
                        data-tip
                    >
                        <i className="fa fa-trash"></i>
                    </button>
                </div>
            ),
            clickEvent: () => handleViewPopup("Update", data),
        })),
    }

    useEffect(() => {
        fetchRoleTypeData();
    }, []);

    return (
        <>
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1>Admin Users Role</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Admin Users Role</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right hidden-xs">
                            <span onClick={() => handleAddPopup(true, "Add", {})} className="btn btn-outline-primary mr-1" title="">Add New</span>
                        </div>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="body">
                                <div className="table-responsive">
                                    <MDBDataTable
                                        noBottomColumns
                                        className="table table-hover js-basic-example dataTable table-custom spacing5"
                                        entriesOptions={[5, 10, 20, 25]}
                                        entries={10}
                                        paging
                                        pagesAmount={15}
                                        data={body}
                                        // searchTop
                                        sortRows={['title']}
                                    // searchBottom={false}
                                    // onPageChange={()=>{ activePage: 2, pagesAmount: 5 }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <AdminUserRoleAdd fetchRoleTypeData={fetchRoleTypeData} eventType={eventType} updateData={updateData} addPopupStatus={addPopupStatus} handleAddPopup={handleAddPopup} />
                <AdminUserRoleDelete fetchRoleTypeData={fetchRoleTypeData} deleteId={deleteId} deletePopupStatus={deletePopupStatus} handleCloseDelete={handleCloseDelete} />
                {/* <div className={`extraspace_search_div search_div${isSearchbar ? " open" : ""}`}>
                    <div className="card member_master_sidebar_scrool">
                        <div className="member_edit_pop_flex mb-3 text-end">
                            <h3>Add Role Type</h3>
                            <div className="input-group-append">
                                <span onClick={() => toggleSearchBar(false)} className="search_toggle btn btn-danger"><i className="fa fa-times"></i></span>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <div className="body  application_body_side">
                                <form id="basic-form" method="post" noValidate>
                                    <div className="row ">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Role</label>
                                                <input type="Text" className="form-control" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 check_box_mar0">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <p>Module Name</p>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <p>View</p>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <p>Create</p>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <p>Update</p>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <p>Delete</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <p>	Membership Application</p>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <label class="fancy-checkbox">
                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                        <span></span>
                                                    </label>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <label class="fancy-checkbox">
                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                        <span></span>
                                                    </label>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <label class="fancy-checkbox">
                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                        <span></span>
                                                    </label>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <label class="fancy-checkbox">
                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                        <span></span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <p>	Membership Package</p>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <label class="fancy-checkbox">
                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                        <span></span>
                                                    </label>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <label class="fancy-checkbox">
                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                        <span></span>
                                                    </label>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <label class="fancy-checkbox">
                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                        <span></span>
                                                    </label>
                                                </div>
                                                <div className="col-2 text-center">
                                                    <label class="fancy-checkbox">
                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                        <span></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 member_button_flex">
                                            <button className="btn btn-outline-info">ADD</button>
                                            <a onClick={() => toggleSearchBar(false)} className="btn btn-outline-danger">Close</a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`extraspace_search_div search_div${isSearchbar1 ? " open" : ""}`}>
                    <div className="card member_master_sidebar_scrool">
                        <div className="member_edit_pop_flex mb-3 text-end">
                            <h3>Edit Role </h3>
                            <div className="input-group-append d-flex gap-10">
                                <span onClick={() => toggleSearchBar1(false)} className="search_toggle btn btn-danger"><i className="fa fa-times"></i></span>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <div className="body  application_body_side">
                                <fieldset>
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="body">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <small className="text-muted"><b>Role Type</b> </small>
                                                            <p>Associate</p>
                                                        </div>
                                                        <div className="col-lg-12 col-md-12 check_box_mar0">
                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    <p> Module Name </p>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <p> View </p>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <p> Create </p>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <p> Update </p>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <p> Delete </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    <p>	Membership Application</p>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <label class="fancy-checkbox">
                                                                        <input type="checkbox" name="checkbox" required="" checked data-parsley-errors-container="#error-checkbox" />
                                                                        <span></span>
                                                                    </label>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <label class="fancy-checkbox">
                                                                        <input type="checkbox" name="checkbox" required="" checked data-parsley-errors-container="#error-checkbox" />
                                                                        <span></span>
                                                                    </label>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <label class="fancy-checkbox">
                                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                                        <span></span>
                                                                    </label>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <label class="fancy-checkbox">
                                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                                        <span></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    <p>	Membership Package</p>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <label class="fancy-checkbox">
                                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                                        <span></span>
                                                                    </label>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <label class="fancy-checkbox">
                                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                                        <span></span>
                                                                    </label>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <label class="fancy-checkbox">
                                                                        <input type="checkbox" name="checkbox" required="" checked data-parsley-errors-container="#error-checkbox" />
                                                                        <span></span>
                                                                    </label>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <label class="fancy-checkbox">
                                                                        <input type="checkbox" name="checkbox" required="" data-parsley-errors-container="#error-checkbox" />
                                                                        <span></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    );

}
export default AdminUserRole
